import { Box, Button, Grid, Modal, Paper, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import useBuyFactorStore from "../../../store/into-warehouse/useBuyFactorStore";
import CustomModal from "../../global/custom-modal";
import ConfilictCreate from "./modals/confilict-create";
import ConfilictInfo from "./modals/confilict-info";

const useStyles = makeStyles({
  buyFactorDetailItem: {
    padding: "12px",
    borderBottom: "1px solid #E2E2E2",
    textAlign: "center",
    "& span": {
      display: "block",
      color: "#ABACBE",
      fontWeight: "100",
    },
    "&:last-child": {
      borderBottom: 0,
    },
    "& Button": {
      margin: "0 2px",
      minWidth: "110px",
      fontSize: "0.8rem",
    },
  },
});

const BuyFactorDetailItem = ({
  product_name,
  total_count,
  into_warehouse_count,
  is_conflict,
  conflict_id,
  item_id,
  product_id,
  date,
}) => {
  const classes = useStyles();
  const history = useHistory();
  const [openConfilicInfo, setOpenConfilicInfo] = useState(false);
  const [openConfilicCreate, setOpenConfilicCreate] = useState(false);
  const factorID = useBuyFactorStore((store) => store.factorID);
  const setProductID = useBuyFactorStore((store) => store.setProductID);
  const setDate = useBuyFactorStore((store) => store.setDate);
  const setProductName = useBuyFactorStore((store) => store.setProductName);

  const navigate = (product_id, factorID) => {
    history.push(`/panel/barcode-list/${factorID}/${product_id}`);
    setProductID(product_id);
    setDate(date);
    setProductName(product_name);
  };

  return (
    <Box className={classes.buyFactorDetailItem}>
      <Grid container spacing={1}>
        <Grid item xs={4}>
          <Typography variant="h3" fontWeight="700" textAlign="right">
            {product_name}
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography variant="h3" fontWeight="700">
            <span>تعداد کل</span>
            {total_count}
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography variant="h3" fontWeight="700">
            <span>تعداد وارد شده</span>
            {into_warehouse_count}
          </Typography>
        </Grid>
      </Grid>
      <Box mt={2}>
        <Button
          variant="contained"
          onClick={() => navigate(product_id, factorID)}
        >
          ورود به انبار
        </Button>
        {is_conflict === 1 ? (
          <>
            <Button
              variant="outlined"
              onClick={() => setOpenConfilicInfo(true)}
            >
              مشاهده مغایرت
            </Button>
            <CustomModal
              openModal={openConfilicInfo}
              setOpenModal={setOpenConfilicInfo}
              titleModal="مشاهده مغایرت کالا"
            >
              <ConfilictInfo id={conflict_id} closeModal={setOpenConfilicInfo} />
            </CustomModal>
          </>
        ) : (
          <>
            <Button
              variant="outlined"
              onClick={() => setOpenConfilicCreate(true)}
            >
              اعلام مغایرت
            </Button>
            <CustomModal
              openModal={openConfilicCreate}
              setOpenModal={setOpenConfilicCreate}
              titleModal="اعلام مغایرت کالا"
            >
              <ConfilictCreate closeModal={setOpenConfilicCreate} id={item_id} />
            </CustomModal>
          </>
        )}
      </Box>
    </Box>
  );
};
export default BuyFactorDetailItem;
